import { useState } from 'react'
import { motion } from 'framer-motion'
import { cn } from '../../lib/utils'

const TabGroup = ({ tabs, defaultTab, className, children }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id)

  return (
    <div className={cn("w-full", className)}>
      {/* Tab Headers */}
      <div className="flex items-center border-b border-neutral-200 mb-6">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={cn(
                "relative px-4 py-3 text-p1-r font-medium transition-all duration-200 whitespace-nowrap",
                activeTab === tab.id
                  ? "text-primary-teal"
                  : "text-neutral-600 hover:text-neutral-900"
              )}
            >
              {tab.icon && (
                <tab.icon className="w-4 h-4 mr-2 inline" />
              )}
              {tab.label}
              
              {/* Active indicator */}
              {activeTab === tab.id && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary-teal"
                  initial={false}
                  transition={{ type: "spring", stiffness: 500, damping: 30 }}
                />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="relative">
        {tabs.map((tab) => (
          <motion.div
            key={tab.id}
            initial={false}
            animate={{
              opacity: activeTab === tab.id ? 1 : 0,
              y: activeTab === tab.id ? 0 : 10
            }}
            transition={{ duration: 0.2 }}
            className={cn(
              "w-full",
              activeTab === tab.id ? "block" : "hidden"
            )}
          >
            {typeof children === 'function' ? children(tab.id) : tab.content}
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default TabGroup
